import * as React from 'react';
import { themeGlobals, useTokenContext } from '@sail/engine/deprecated';
import { createViewConfig, dynamic, usePortalTokenStyles } from '@sail/engine';
import { view } from '../../deprecated/view';
export const InteropConfig = createViewConfig({
    context: false,
    element: true,
    props: {}
});
/**
 * This component reapplies design tokens in both the former and refreshed token systems for use
 * within a React portal.
 *
 * This enables layer interoperability with components that use tokens from either system.
 */ export const LayerInterop = InteropConfig.createView(({ legacyIntents = [], ...props })=>{
    const tokens = useTokenContext();
    return /*#__PURE__*/ React.createElement(view.div, {
        ...props,
        uses: [
            ...legacyIntents,
            themeGlobals,
            tokens.styles
        ]
    });
}, {
    uses: dynamic(()=>[
            usePortalTokenStyles()
        ])
});

//# sourceMappingURL=LayerInterop.js.map